import React from 'react';
import { useParams } from 'react-router-dom';
import { AIRemarksContainer } from '../../remarks/components/aiRemarksContainer';
import { AnalysisRemarkKeys } from '../../remarks/config';
import { useCaseNotes } from '../../../hooks/useCaseNotes';
import { CaseNoteType } from '../../../api/CaseNote';
import { ContentType } from '../../../api/Content';
import { useAppDispatch, useAppSelector } from '../../../app/store';
import {
    selectAdditionalAnalysisLoadingStatus,
    selectAdditionalAnalysisRemarks,
} from '../logic/additionalAnalysisSlice';
import { fetchAdditionalAnalysis } from '../../../thunks/AnalysisStep';
import { InlineLoadingSpinner } from '../../../components/ui/spinners/InlineLoadingSpinner';
import { ErrorDisplay } from '../../../components/ui/error/ErrorDisplay';
import { RETRIEVING_DATA_SUBTITLE } from '../../../lib/constants';

const AdditionalAnalysisAccordionContent: React.FC = () => {
    const dispatch = useAppDispatch();
    const { id: case_id } = useParams<{ id: string }>();

    const loadingStatus = useAppSelector(selectAdditionalAnalysisLoadingStatus);
    const additionalAnalysisRemarks = useAppSelector(selectAdditionalAnalysisRemarks);

    const handleRetry = () => {
        if (case_id) {
            dispatch(fetchAdditionalAnalysis({ case_id }));
        }
    };

    const {
        initialValue,
        ...remarksProps
    } = useCaseNotes({
        noteType: CaseNoteType.additional_analysis
    });

    const finalInitialValue = additionalAnalysisRemarks?.value ?? initialValue;

    if (loadingStatus === 'pending') {
        return (
            <InlineLoadingSpinner
                message="Loading Additional Analysis..."
                subtitle={RETRIEVING_DATA_SUBTITLE}
                className="min-h-[400px]"
            />
        );
    }

    if (loadingStatus === 'failed') {
        return (
            <ErrorDisplay
                error="Failed to load additional analysis. Please retry."
                onRetry={handleRetry}
            />
        );
    }

    return (
        <div>
            <AIRemarksContainer
                remarkKey={AnalysisRemarkKeys.AdditionalAnalysis}
                initialValue={finalInitialValue}
                {...remarksProps}
                disableGenerate={true}
            />
        </div>
    );
};

export default AdditionalAnalysisAccordionContent;
